import { ClothesSize, ClothesColors, ClothesGender } from "../models/clothes/clothes.model";

export const sizeOptions: ClothesSize[] = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];

export const colorOptions: ClothesColors[] = [
    "white", "black", "gray", "cream", "blue", "red", "pink", "orange",
    "yellow", "purple", "green", "brown"
];

export const colorLabels: Record<ClothesColors, string> = {
    white: "E bardhë",
    black: "E zezë",
    gray: "Gri",
    cream: "Krem",
    blue: "Blu",
    red: "E kuqe",
    pink: "Rozë",
    orange: "Portokalli",
    yellow: "E verdhë",
    purple: "Vjollcë",
    green: "E gjelbër",
    brown: "Kafe",
};

/** Hex for each color (for swatches in dropdowns) */
export const colorHex: Record<ClothesColors, string> = {
    white: "#ffffff",
    black: "#1a1a1a",
    gray: "#9ca3af",
    cream: "#fef3c7",
    blue: "#3b82f6",
    red: "#ef4444",
    pink: "#ec4899",
    orange: "#f97316",
    yellow: "#eab308",
    purple: "#a855f7",
    green: "#22c55e",
    brown: "#92400e",
};

export const genderOptions: { value: ClothesGender; label: string }[] = [
    { value: "female", label: "Femër" },
    { value: "male", label: "Mashkull" },
    { value: "both", label: "Të dyja" },
];
